<mat-icon
  class="cancel-confirm-dialog"
  [svgIcon]="'small-cancel'"
  (click)="onClose()"
></mat-icon>
<mat-dialog-content
  [ngClass]="{ 'mat-dialog-content-with-message': message !== null }"
>
  <span class="white-spaced">
    {{ text | translate }}
  </span>
  <mat-form-field *ngIf="message" appearance="outline">
    <textarea matInput [formControl]="message" maxlength="250"></textarea>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <app-button-outline [action]="rejectAction"></app-button-outline>
  <app-button-outline
    *ngIf="confirm !== ''"
    [action]="confirmAction"
    [isHighlight]="isHighlightForConfirm"
    [disabled]="message ? this.message.value!.length < 1 : false"
  ></app-button-outline>
</mat-dialog-actions>
